import React, { useReducer } from 'react';
import PropTypes from 'prop-types';

const PageContext = React.createContext();

const reducer = (state, { type, payload }) => {
  // console.log('reducer');
  const { sections } = state;
  switch (type) {
    case 'ADD_SECTION':
      return {
        ...state,
        sections: [...sections].concat(payload),
      };
    default:
      return state;
  }
};

const PageState = ({
  pageId, pagePath, parentId, children,
}) => {
  // useReducer to optimize performance to pass dispatch instead of callbacks
  // useState would cause unnecessary rerenders for sections reporting their existence
  const [state, dispatch] = useReducer(reducer, { sections: [] });
  const addSection = (section) => {
    dispatch({ type: 'ADD_SECTION', payload: section });
  };

  return (
    <PageContext.Provider
      value={{
        state,
        addSection,
        pageId,
        pagePath,
        parentId,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

PageState.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  pageId: PropTypes.string.isRequired,
  pagePath: PropTypes.string.isRequired,
  parentId: PropTypes.string,
};

PageState.defaultProps = {
  parentId: '',
};

export default PageState;

// eslint-disable-next-line react/prop-types
// export const wrapRootElement = ({ element }) => <HanaState>{element}</HanaState>;

export { PageContext };
